import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { QrCodeIcon } from "@jti/brand-icons/qr-code";
import { Button, type ButtonSize } from "@jti/core-components/components/Button";

type ShareProfileButtonProps = { size: ButtonSize; toggleDialog: () => void; label?: string; fullWidth?: boolean };

export const ShareProfileButton: FC<ShareProfileButtonProps> = ({ size, toggleDialog, label, fullWidth }) => {
  const { __ } = useTranslations();

  return (
    <Button
      data-testid="openSharableProfileDialog"
      onClick={toggleDialog}
      size={size}
      fullWidth={fullWidth}
      variant="secondary"
      aria-label={__("share_profile.button_label")}
      iconBefore={QrCodeIcon}
    >
      {label ?? ""}
    </Button>
  );
};
